module.exports = __webpack_public_path__ + "img/21.67e4c8d5.png";